import React, { useContext } from 'react';
import { Event, getEventSalesStatus } from '../../../../../model/event';
import { loadVenuePlan } from '../../../../../model/venue';
import { PrintPlan } from './PrintPlan';
import { PrintHistory } from './PrintHistory/print_history';
import { PrintGeneralAdmission } from './PrintGeneralAdmission';
import { loadPrintedTickets } from '../../../../../model/ticket';
import { ActivitiesContext } from '../../../../../components/Activities/Activities';
import { useAsync } from '../../../../../model/data';
import { useErrorHandler, useReloadKey } from '../../../../../util/react-util';
import { handleError } from '../../../../../model/notification';
import { LocalTicketEmailTemplate } from './local_ticket_email_template';

export function Print({ event }: { event: Event }): JSX.Element {
  const { reloadActivities } = useContext(ActivitiesContext);
  const [, venuePlanError] = useAsync(() => loadVenuePlan(event));
  const [, printedTicketsError] = useAsync(() => loadPrintedTickets(event));
  const [printingOrdersKey, reloadPrintingOrders] = useReloadKey();
  useErrorHandler(venuePlanError);
  useErrorHandler(printedTicketsError);

  const usePlan = event.venueLayout.requiresMapSelection;
  const section = !usePlan && event.venuePlan?.sections?.[0];
  async function reloadData({
    generalSectionIds = [],
    seated = false,
  }: {
    generalSectionIds?: Array<string>;
    seated?: boolean;
  } = {}): Promise<void> {
    try {
      reloadActivities();
      const salesDidChange = seated || generalSectionIds.length > 0;
      if (salesDidChange) {
        getEventSalesStatus(event.id, { force: true });
      }
      await Promise.all([loadPrintedTickets(event), reloadPrintingOrders()]);
    } catch (e) {
      handleError(e);
    }
  }

  return (
    <>
      {usePlan && event.venuePlan && <PrintPlan event={event} onTicketsCreated={reloadData} />}
      {section && <PrintGeneralAdmission event={event} section={section} onTicketsCreated={reloadData} />}
      <PrintHistory
        event={{ id: event.id, venuePlan: event.venuePlan }}
        onTicketUpdate={reloadData}
        onTicketsRefund={reloadData}
        printingOrdersKey={printingOrdersKey}
      />
      <LocalTicketEmailTemplate eventId={event.id} />
    </>
  );
}
